import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, InputLabel, Select, MenuItem, DialogActions, Button, FormControl, DialogTitle, Tooltip, Slider, makeStyles } from '@material-ui/core';
import InfoIcon from "@material-ui/icons/Info";
import { useBuilder } from '../../useBuilder';

const useStyles = makeStyles((theme) => ({
    mobileSpacing: {
        [theme.breakpoints.down("xs")]: {
            marginTop: "2em !important",
        },
    },  
    slider: {
        padding: '25px 0px',
    },
    labelStyle: {
        fontSize: 21, 
        transform: "translate(0, -5.5px) scale(0.75)", 
        transformOrigin: 'top left', 
        "&:focused": {
            color: "#1976d2"
        }
    }
}));

interface Props {
    showSettings: boolean;
    disabled: boolean;
    toggleSettingsOpen: () => void;
    handlePreferenceChange: (voice:string, speed:number) => void;
}

const textVoice:{displayName:string, value:string }[] = [
    {displayName: "Female - Australian", value: "en-AU-Catherine"}, 
    {displayName: "Male - British", value: "en-GB-George"}, 
    {displayName: "Female - British", value:"en-GB-HazelRUS"},
    {displayName: "Male - American", value: "en-US-BenjaminRUS"},
    {displayName: "Female - American", value: "en-US-JessaRUS"}]

export function TextToSpeechSettings(props: Props){
    const { toggleSettingsOpen, showSettings, handlePreferenceChange, disabled} = props;
    const { preferences} = useBuilder();
    const classes = useStyles();

    const [voice, setVoice] = useState<string>(preferences.textToSpeechVoice);
    const [speed, setSpeed] = useState<number>(preferences.textToSpeechSpeed);

    useEffect(() => {
        setVoice(preferences.textToSpeechVoice ? preferences.textToSpeechVoice : "en-US-BenjaminRUS");
        setSpeed(preferences.textToSpeechSpeed);
    }, [preferences])

    const handleSpeedChange = (value:number) => {
        let rounded:number = parseFloat(value.toFixed(2));
        setSpeed(rounded)
    }

    return (
        <Dialog open={showSettings} onClose={toggleSettingsOpen}>
        <DialogTitle id="Speech-Settings-Title">Audio Playback Settings</DialogTitle>
        <DialogContent style={{ overflowX: "hidden"}}>
            <FormControl fullWidth margin="normal">
                <Tooltip title="Choose Speaker Voice" placement="top">
                    <InputLabel htmlFor="Voice" style={{ fontSize: 21 }}>
                        Speaker Voice <InfoIcon style={{ fontSize: 17 }} />
                    </InputLabel>
				</Tooltip>
                    <Select 
                    inputProps={{
                        name: "Voice",
                        id: "Voice"
                        }}
                        value={voice}
                        onChange={(e:React.ChangeEvent<{value: unknown}>) => {setVoice(e.target.value as string)}}
                        disabled={disabled}
                        className={classes.mobileSpacing}
                    >
                        { textVoice.map( ({displayName, value}) => <MenuItem key={value} value={value}>{displayName}</MenuItem> )}
                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <Tooltip title="Choose Speaker Speed" placement="top">
                        <InputLabel htmlFor="TextToSpeechSpeed" className={classes.labelStyle}>
                            Speaker Speed <InfoIcon style={{ fontSize: 17 }}/> - {speed}x
                        </InputLabel>
                    </Tooltip>
                    <Slider
                        id="TextToSpeechSpeed"
                        color='primary'
                        min={0.5} 
                        max={2} 
                        value={speed}
                        onChange={(e, value) => {handleSpeedChange(value as number)}}
                        className={classes.mobileSpacing}
                    />
                </FormControl>
            <DialogActions>
                <Button disabled={disabled} onClick={toggleSettingsOpen} color="primary">
                    Cancel
                </Button>
                <Button disabled={disabled} onClick={() =>{handlePreferenceChange(voice, speed)}} color="primary">
                    Apply Settings
                </Button>
            </DialogActions>
        </DialogContent>
    </Dialog>
    );
}